import { DeleteIcon } from '@chakra-ui/icons';
import {
  Button,
  Flex,
  Input,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  UnorderedList,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { heptathlonEventListType, heptathlonEventType } from '../common/types';
import { calcPoint, calcRecord } from './components/calcWomanPoint';
import { eventNameDict } from './components/eventNameDict';
import { HowToName } from './components/howToName';
import { HowToUse } from './components/howToUse';
import { Links } from './components/links';
import { ScoreInput } from './components/scoreInput';
import { TextBox } from './components/textbox';

export const CalculatorHeptathlonSave = () => {
  //記録の箱
  const [records, setRecords] = useState<heptathlonEventListType>({
    i00h: '',
    hj: '',
    sp: '',
    z00: '',
    lj: '',
    jt: '',
    B00: '',
  });

  // 得点もinputでいじるのでこれも箱として良い
  const [points, setPoints] = useState<heptathlonEventListType>({
    i00h: '',
    hj: '',
    sp: '',
    z00: '',
    lj: '',
    jt: '',
    B00: '',
  });

  // 種目名を入れるとそれより前に行われたやつを全部足す関数
  const calcTotalPoint = (EventName: heptathlonEventType) => {
    let totalPoint = 0;
    for (const event in points) {
      const score = Number(points[event as heptathlonEventType]) || 0;
      totalPoint += score;
      if (event === EventName) {
        break;
      }
    }
    return totalPoint;
  };

  //記録を入力すると得点が表示される関数
  const handleChange =
    (key: heptathlonEventType) =>
    (score: React.ChangeEvent<HTMLInputElement>) => {
      const record = Number(score.target.value);
      const newRecords = { ...records, [key]: record };
      const calucalatedPoint = calcPoint(key, record);
      const newPoints = { ...points, [key]: calucalatedPoint };

      setRecords(newRecords);
      setPoints(newPoints);

      // 🔽 自動保存（七種用キー名）
      localStorage.setItem(
        'HepData_lastUsed',
        JSON.stringify({
          name: 'last-used',
          data: newRecords,
          point: newPoints,
        })
      );
    };

  //得点を入力すると記録が表示される関数
  const handlePointChangeParent =
    (key: heptathlonEventType) =>
    (result: React.ChangeEvent<HTMLInputElement>) => {
      const point = Number(result.target.value);
      const newPoints = { ...points, [key]: point };
      const score = calcRecord(key, point);
      const newRecords = { ...records, [key]: score };

      setPoints(newPoints);
      setRecords(newRecords);

      // 🔽 自動保存（七種用キー名）
      localStorage.setItem(
        'HepData_lastUsed',
        JSON.stringify({
          name: 'last-used',
          data: newRecords,
          point: newPoints,
        })
      );
    };

  //記録と得点をリセットする関数
  const reset = () => {
    setPoints({
      i00h: '',
      hj: '',
      sp: '',
      z00: '',
      lj: '',
      jt: '',
      B00: '',
    });
    setRecords({
      i00h: '',
      hj: '',
      sp: '',
      z00: '',
      lj: '',
      jt: '',
      B00: '',
    });
  };
  const eventList = Object.keys(records) as heptathlonEventType[];

  //ここからSAVE用のモーダル部分

  const {
    isOpen: isOpenLoad,
    onOpen: onOpenLoad,
    onClose: onCloseLoad,
  } = useDisclosure();
  const [inputName, setInputName] = useState<string>('');
  const [dataList, setDataList] = useState<string[]>([]);
  const [selectedData, setSelectedData] = useState<string | null>(null);

  // ローカルストレージからデータを取得して初期化
  useEffect(() => {
    const storageData = localStorage.getItem('HepData');
    if (storageData) {
      const parsedData: {
        name: string;
        data: heptathlonEventListType;
        point: heptathlonEventListType;
      }[] = JSON.parse(storageData);
      const savedData: string[] = parsedData.map((item) => item.name);
      setDataList(savedData);
    }

    // 🔽 自動復元：number → string に変換してからセット
    const lastUsed = localStorage.getItem('HepData_lastUsed');
    if (lastUsed) {
      try {
        const parsed = JSON.parse(lastUsed);

        const convertedData = Object.fromEntries(
          Object.entries(parsed.data).map(([k, v]) => [k, String(v)])
        ) as heptathlonEventListType;

        const convertedPoint = Object.fromEntries(
          Object.entries(parsed.point).map(([k, v]) => [k, String(v)])
        ) as heptathlonEventListType;

        setRecords(convertedData);
        setPoints(convertedPoint);
      } catch (e) {
        console.error('HepData_lastUsed 読み込み失敗:', e);
      }
    }
  }, []);

  interface Data {
    name: string;
    data: heptathlonEventListType;
    point: heptathlonEventListType;
  }
  //ここで保存したデータを呼び出す
  const saveData = (): void => {
    if (inputName.trim() !== '') {
      const newData: Data = {
        name: inputName,
        data: records,
        point: points,
      };
      const existingData: Data[] = JSON.parse(
        localStorage.getItem('HepData') || '[]'
      ) as Data[];

      const isNameExist = existingData.some(
        (data: Data) => data.name === inputName
      );

      if (!isNameExist) {
        // 名前付きで保存
        localStorage.setItem(
          'HepData',
          JSON.stringify([...existingData, newData])
        );

        // 🔽 追加：直近使用データとしても保存（自動復元用）
        localStorage.setItem('HepData_lastUsed', JSON.stringify(newData));

        setDataList((prevDataList: string[]) => [...prevDataList, inputName]);
        setInputName('');
      } else {
        alert('この名前は使用されています');
      }
    }
  };

  const deleteData = (deletedItem: string) => {
    const storageData = localStorage.getItem('HepData');
    let parsedData = null;
    if (storageData) {
      parsedData = JSON.parse(storageData) as {
        name: string;
        data: heptathlonEventListType;
        point: heptathlonEventListType;
      }[];
    }
    if (!parsedData) return;

    const updatedDataList = parsedData.filter(
      (item) => item.name !== deletedItem
    );
    const dataNameList = updatedDataList.map((d) => d.name);
    setDataList(dataNameList);
    localStorage.setItem('HepData', JSON.stringify(updatedDataList)); // 最初の要素を保存するか、データがない場合は空文字列を保存
    // 削除されたデータが選択されていた場合、選択をリセット
    if (selectedData === deletedItem) {
      setSelectedData(null);
    }
  };

  const showSelectedData = (selectedItem: string) => {
    const storageData = localStorage.getItem('HepData');

    if (storageData) {
      const parsedData: {
        name: string;
        data: heptathlonEventListType;
        point: heptathlonEventListType;
      }[] = JSON.parse(storageData);

      console.log('parseData', parsedData);

      const selectedData = parsedData.find(
        (item) => item.name === selectedItem
      );

      if (selectedData) {
        // 選択されたデータが見つかった場合の処理
        console.log('Selected Data:', selectedData);
        setRecords(selectedData.data); // dataプロパティだけをセット
        setPoints(selectedData.point); // dataプロパティだけをセット
      }
    }

    setSelectedData(selectedItem);
    onCloseLoad();
  };

  return (
    <div>
      {/* タイトル部分の実装 */}
      <div
        style={{ marginLeft: '120px', marginTop: '16px', marginBottom: '16px' }}
      >
        七種競技得点表
      </div>
      {/* 上部のボタン部分の実装 */}
      <div style={{ display: 'flex', width: '360px', marginBottom: '10px' }}>
        <div style={{ marginLeft: '36px', width: '65%' }}>
          <HowToUse />
        </div>
        <Button
          onClick={reset}
          size="xs"
          style={{ color: 'black', backgroundColor: '#fff4fd' }}
        >
          Reset
        </Button>
      </div>
      {/* 得点表部分の実装 */}
      {eventList.map((eN, index) => {
        const color = index % 2 === 0 ? '#fff4fd' : '#ffffff';
        return (
          <div style={{ backgroundColor: color }} key={index}>
            <ScoreInput
              title={eventNameDict[eN]}
              record={records[eN]}
              point={points[eN]}
              handleScoreChange={handleChange(eN)}
              totalScore={calcTotalPoint(eN)}
              handlePointChange={handlePointChangeParent(eN)}
            />
          </div>
        );
      })}
      <div style={{ marginLeft: '16px' }}>---総合---</div>
      <div
        style={{
          display: 'flex',
          width: '360px',
          textAlign: 'center',
        }}
      >
        <div style={{ width: '30%', marginLeft: '10pt' }}>
          1日目：{calcTotalPoint('z00')}
        </div>
        <div style={{ width: '30%', marginLeft: '10pt' }}>
          2日目：{calcTotalPoint('B00') - calcTotalPoint('z00')}
        </div>
        <div style={{ width: '20%', textAlign: 'right' }}>合計：</div>
        <div style={{ width: '20%', textAlign: 'right', marginRight: '1pt' }}>
          {calcTotalPoint('B00')} 点
        </div>
      </div>
      {/* 下部のボタン部分の実装 */}
      <div style={{ marginTop: '10px', marginLeft: '20px' }}>
        <Flex justifyContent="space-between" maxWidth="300px">
          <Button size="xs" onClick={onOpenLoad}>
            Save/Load
          </Button>

          <Button
            onClick={reset}
            size="xs"
            style={{ color: 'black', backgroundColor: '#f5f5f5' }}
          >
            Reset
          </Button>
        </Flex>
      </div>
      {/* ロード用のモーダル */}
      <Modal isOpen={isOpenLoad} onClose={onCloseLoad}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            Save/Load
            <div style={{ fontSize: '10px' }}>
              ※１週間アクセスがないとデータが消える場合があります
            </div>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div>
              <div>
                <Input
                  type="text"
                  value={inputName}
                  onChange={(e) => setInputName(e.target.value)}
                  // placeholder="例）2024年 日本選手権 予想"
                />
              </div>
              <div
                style={{
                  marginTop: '5px',
                  marginLeft: '10px',
                  marginRight: '10px',
                  display: 'flex',
                  justifyContent: 'space-between', // 要素の間にスペースを均等に配置
                  alignItems: 'center', // 要素を縦方向中央に配置
                }}
              >
                <div>
                  <HowToName />
                </div>

                <Button size="xs" onClick={saveData}>
                  名前を付けて保存
                </Button>
              </div>
              <br></br>
              <span style={{ fontSize: 12 }}>-データリスト-</span>
              <div>
                <UnorderedList>
                  {dataList.map((item, index) => (
                    <ListItem key={index} style={{ padding: '0px 0' }}>
                      {item}
                      &nbsp;
                      <Button
                        size="xs"
                        onClick={() => showSelectedData(item)}
                        style={{ marginRight: '5px', marginLeft: '5px' }}
                      >
                        Load
                      </Button>
                      &nbsp;
                      <Button size="xs" onClick={() => deleteData(item)}>
                        <DeleteIcon />
                      </Button>
                    </ListItem>
                  ))}
                </UnorderedList>
              </div>
            </div>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onCloseLoad}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>{' '}
      <TextBox />
      <Links />
    </div>
  );
};
